import { motion } from "framer-motion";

const TherapyStyleSection = () => {
  return (
    <section id="therapy-style" className="therapy-style-section py-24 px-6 bg-secondary">
      <div className="max-w-5xl mx-auto">
        <div className="grid md:grid-cols-[5fr_9fr] gap-12 lg:gap-16">
          {/* Left — sticky heading + quote */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="md:sticky md:top-32 md:self-start"
          >
            <h2 className="therapy-style-heading text-3xl md:text-4xl font-heading font-medium text-foreground mb-4">
              Therapy Style
            </h2>
            <div className="w-16 h-px bg-accent mb-6" />
            <p className="font-body text-foreground/80 italic leading-relaxed mb-1">
              "The privilege of a lifetime is to become who you truly are"
            </p>
            <p className="font-body text-muted-foreground text-sm">– Carl Jung</p>
          </motion.div>

          {/* Right — paragraphs */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="therapy-style-description space-y-5 font-body text-muted-foreground font-light leading-relaxed"
          >
            <p>
              Therapy at Stillwater is all about you and your needs. We don't prescribe pre-determined pathways. Every
              plan is custom-tailored for your life and your goals. Together, we create a space where you can slow down,
              be honest, and dive into the deep places.
            </p>
            <p>
              We integrate holistic approaches such as somatic psychology and mindfulness with evidence-based approaches
              such as cognitive behavioral therapy (CBT), dialectical behavior therapy (DBT), IFS, attachment theory, and
              psychodynamic theory. We adapt each technique to serve you best. Whether that's processing something painful,
              untangling a difficult relationship, or simply learning to be kinder to yourself – we go at your pace.
            </p>
            <p>
              Above all, we want you to feel safe at Stillwater. Therapy shouldn't feel like another obligation. It
              should feel like a place where every part of you feels seen.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default TherapyStyleSection;
